import React, { useState } from 'react'
import propTypes from 'prop-types'
import Box from '@material-ui/core/Box'

import Http from '../../shared/http'
import { GenericErrorModal } from './GenericErrorModal'
import { Modal, ModalHeader, ModalSubHeader, ModalContent } from './index'
import { Button } from '../Button'

export const GoToDesktopModal = ({ open, onClose, tenantSlug, sendLoginLinkPath, onCreateNewScenario }) => {
  const [sendingLoginLink, setSendingLoginLink] = useState(false)
  const [errorSendingLoginLink, setErrorSendingLoginLink] = useState(false)
  const [showDesktopLink, setShowDesktopLink] = useState(false)

  if (errorSendingLoginLink) {
    return (
      <GenericErrorModal
        open={open}
        onClose={() => {
          setShowDesktopLink(false)
          onClose()
        }}
      />
    )
  }
  if (showDesktopLink) {
    return (
      <DesktopLinkContent
        open={open}
        onClose={() => {
          setShowDesktopLink(false)
          onClose()
        }}
        tenantSlug={tenantSlug}
      />
    )
  }

  return (
    <Modal open={open} onClose={onClose}>
      <ModalHeader>
        Choose your experience
      </ModalHeader>
      <ModalSubHeader>
        Scenario planning on mobile is currently in beta, for the full experience you can continue on desktop.
      </ModalSubHeader>
      <ModalContent className='centered'>
        <Box display='flex' flexDirection='column' className='gap-4'>
          <Button
            primary
            trackAs='Mobile: Create Scenario Plan'
            onClick={() => onCreateNewScenario()}
          >
            Continue on Mobile
          </Button>
          <Button
            secondary
            disabled={sendingLoginLink}
            trackAs='Mobile: Send login link'
            onClick={async () =>
              await onSubmit(sendLoginLinkPath, setShowDesktopLink, setErrorSendingLoginLink, setSendingLoginLink)
            }
          >
            {sendingLoginLink ? 'Sending login link...' : 'Continue on Desktop'}
          </Button>
          <Button className='text-link mt-4' onClick={onClose}>Let me see my plan</Button>
        </Box>
      </ModalContent>
    </Modal>
  )
}

const DesktopLinkContent = ({ open, onClose, tenantSlug }) => {
  const loginLink = `https://planner.wealthbit.co/auth/login?organization=${tenantSlug}`
  return (
    <Modal open={open} onClose={onClose}>
      <ModalHeader>
        Your link is on it's way
      </ModalHeader>
      <ModalSubHeader>
        To make things easy, we've sent you a login link to your email.
      </ModalSubHeader>
      <ModalContent className='centered'>
        <ul className="list-decimal">
          <li>Go to <a href={loginLink}>{loginLink}</a> on your computer</li>
          <li>Login using the details you signed up with</li>
          <li>Click "Create new scenario"</li>
        </ul>

        <Box display='flex' flexDirection='column' className='gap-4'>
          <Button className='button' secondary onClick={onClose}>Let me see my plan</Button>
        </Box>
      </ModalContent>
    </Modal>
  )
}

const onSubmit = async (sendLoginLinkPath, setShowDesktopLink, setErrorSendingLoginLink, setSendingLoginLink) => {
  try {
    setSendingLoginLink(true)
    const response = await Http.request(sendLoginLinkPath, 'GET')
    if (response.ok) {
      setSendingLoginLink(false)
      setShowDesktopLink(true)
    } else {
      setErrorSendingLoginLink(true)
      setSendingLoginLink(false)
    }
  } catch {
    setErrorSendingLoginLink(true)
    setSendingLoginLink(false)
  }
}

GoToDesktopModal.propTypes = {
  open: propTypes.bool.isRequired,
  close: propTypes.func,
  tenantSlug: propTypes.string.isRequired,
  sendLoginLinkPath: propTypes.string.isRequired,
  onCreateNewScenario: propTypes.func.isRequired,

}
